//import 'date-fns';
import React, {useMemo, useState} from 'react';
import {Button, Col, Container, Row} from "react-bootstrap";
import {Dialog, DialogActions, DialogContent, DialogTitle,} from "@material-ui/core"; 
import Select from "react-select";

import useUserList from "../../shared/functions/useUserList";
import useVendorList from "../../shared/functions/useVendorList"; 
import { DatePicker, Space } from 'antd';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
const { RangePicker } = DatePicker;

 
const FILTER_INITIAL_STATE = { 
    date: {start: null, end: null}, 
    delivery: {vendor: null},
    lastDate:null,
    purchaseEtat:'no'
};

export default function FilterProductToPurchaseModal({show, onSet, onClose}) {

    //const [filter, setFilter] = useState("")
    const [filter, setFilter] = useState(FILTER_INITIAL_STATE)
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedLatestDate, setSelectedLatestDate] = useState(null);
    const [vendorName, setVendorName] = useState(null);
    const [selectedEtat, setSelectedEtat] = useState(null);



    const [selectedDate, handleDateChange] = useState(new Date());
    
    
    const handleDate2Change = (value) => {
        handleDateChange(value) 
        var month = value.getMonth()+1
        var filterbyData = value.getDate()+"-"+month+"-"+value.getFullYear()
        
    }
 
    const {vendors: vendorList, isLoading:isVendorsFetchingLoading} = useVendorList();

    //const {vendors: vendorList, isLoading:isVendorsFetchingLoading} = useVendorList();

     

    const vendors = useMemo(() => {
        return (vendorList && vendorList.map(vendor => ({value: vendor.id, label: vendor.Name}))) ?? []
    }, [vendorList])
    const FILTER_INITIAL = useMemo(() => {
        return FILTER_INITIAL_STATE ?? null
    }, [FILTER_INITIAL_STATE])
/*
    const locations = useMemo(() => {
        const selectedVendor = filter.delivery.vendor;
        const list = (selectedVendor && vendorList.find(vendor => vendor.id === selectedVendor.id)?.Stores) ?? [];
        return list.map(local => ({value: `asd-${local.Name}`, label: local.Name}))
    }, [filter,vendorList])*/

    //######################################################
    /**const handleStatusChange = (status) => {
        setFilter({...filter, status: status})
    }*/

    //######################################################
    const handleStartDateChange = (date) => {
        setFilter({...filter, date: {...filter.date, start: date}})
    }
    const handleLastDateChange = (date) => {
        setSelectedLatestDate(date)
        setFilter({...filter, lastDate:date})
    }

    const handleEndDateChange = (date) => {
        setFilter({...filter, date: {...filter.date, end: date}})
    }

    //######################################################
    const handleUserChange = (user) => {
        user && setFilter({...filter, user: {id: user.value, name: user.label}})
        !user && setFilter({...filter, user: null})
    }

    //######################################################

    const handleVendorChange = (vendor) => {
        vendor && setFilter({...filter, delivery: {...filter.delivery, vendor: {id: vendor.value, name: vendor.label}}})
        vendor && setSelectedVendor(vendor);
        !vendor && setFilter({...filter, delivery: {location: null, vendor: null}})
        !vendor && setSelectedLocation(null);
        !vendor && setSelectedVendor(null);
        setVendorName(vendor.label);
        
    }


    const handleLocationChange = (location) => {
        setSelectedLocation(location);
        location && setFilter({
            ...filter,
            delivery: {...filter.delivery, location: location.label}
        })
        !location && setFilter({...filter, delivery: {...filter.delivery, vendor: null}})
    }

    //######################################################
    const handleApplying = () => {
        localStorage.setItem('ComposeFilter', JSON.stringify(filter));
        console.log(vendorName)
        onSet && onSet(filter)
        handleModalClosing()
    }

    const handleReset = () => {
        localStorage.setItem('ComposeFilter', FILTER_INITIAL_STATE);
        setFilter(FILTER_INITIAL_STATE);
        setSelectedLocation(null);
        setSelectedVendor(null);
    }

    const handleModalClosing = () => {
        onClose && onClose()
    }
 

    const handleCalendarClose = () => console.log("Calendar closed");

    const handleCalendarOpen = () => console.log("Calendar opened");


    return (
        <Dialog fullWidth maxWidth='sm' open={show} onClose={handleModalClosing}>
            <DialogTitle>
                Filter ! {vendorName}
            </DialogTitle>


            <DialogContent>

                {/*___Status___*/}

                {/*___Date___
                <Container className='ml-2'>
                    <Row>
                        <h6>By date 22</h6>
                    </Row>

                    <div style={{margin: 3}}/>

                    <Row>

                        <Col>
                            <Row className='ml-1'>
                                Debut
                            </Row> 
                            <RangePicker getPopupContainer={(triggerNode) => {
                                    return triggerNode.parentNode;
                                }} />
                        </Col> 

                    </Row>
                </Container>*/} 
                {/*___Date___*/}
                <Container className='ml-2'>
                    <Row>
                        <DatePicker getPopupContainer={(triggerNode) => {
                            return triggerNode.parentNode;
                        }}
                                    onChange={handleLastDateChange}
                                    selected={selectedLatestDate}
                        />
                    </Row>
                    <Row>
                        <h6>By date</h6>
                    </Row>

                    <div style={{margin: 3}}/>

                    <Row>

                        <Col>
                            <Row className='ml-1'>
                                Debut
                            </Row> 
                                <DatePicker getPopupContainer={(triggerNode) => {
                                    return triggerNode.parentNode;
                                }} 
                                onChange={handleStartDateChange}
                                selected={filter.date.start} 
                            /> 
                            {
                                /*
                                <DatePicker
                                style={{position: 'absolute', zIndex: 30000}}
                                selected={filter.date.start}
                                onChange={handleStartDateChange}
                                className={'form-control ml-0'}
                                dateFormat={'dd-MM-yyyy'}
                                isClearable
                                placeholderText="I have been cleared!"
                            />
                                */
                            }
                            
                        </Col>

                        <Col>
                            <Row className='ml-1'>
                                Fin
                            </Row>
                            <DatePicker getPopupContainer={(triggerNode) => {
                                    return triggerNode.parentNode;
                                }} 
                                selected={filter.date.end}
                                onChange={handleEndDateChange} 
                            />
                        </Col>

                    </Row>
                </Container>

                <div style={{margin: 20}}/>

                {/*___Vendor and location___*/}
                <Container className='ml-2'>
                    <Row>
                        <h6>By vendor</h6>
                    </Row>

                    <div style={{margin: 3}}/>

                    <Row>
                        <Col md={12}>
                            <Row className='ml-1'>
                                Vendor
                            </Row>
                            <Select
                                isLoading={isVendorsFetchingLoading}
                                isClearable={true}
                                isSearchable={true}
                                value={selectedVendor}
                                options={vendors}
                                style={{width: 400}}
                                onChange={handleVendorChange}

                            />
                        </Col> 
                    </Row>
                    {/* <Row>
                        <Col md={12}>
                        
                            <Row>
                               Etat purchase
                            </Row>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                  <FormControlLabel value="all" control={<Radio />} label="All" />
                  <FormControlLabel value="later" control={<Radio />} label="Save for Later" />
                  <FormControlLabel value="out" control={<Radio />} label="Out of Stock" />
                  <FormControlLabel value="introuvable" control={<Radio />} label="Introuvable" />
                  <FormControlLabel
                     value="disabled"
                     disabled
                     control={<Radio />}
                     label="other"
                   />
                   </RadioGroup>
                </FormControl>
                        </Col> 
                    </Row> */}

                </Container>

                <div style={{height: 200}}/>


            </DialogContent>

            <DialogActions>
                <Button onClick={handleApplying}> Apply </Button>
                <Button className='btn-dark' onClick={handleReset}> Reset </Button>
                <Button variant='outline-secondary' onClick={handleModalClosing}> Close </Button>
            </DialogActions>

        </Dialog>
    )
}
